import { fallbackClients, fallbackInventory, fallbackOrders, fallbackWalletEntries } from './data';
import type { AuditEvent, Client, InventoryItem, Order, WalletEntry } from './types';
import { orderCost, orderPaid } from './business';

export type BusinessState={clients:Client[];orders:Order[];inventory:InventoryItem[];walletEntries:WalletEntry[];audit:AuditEvent[]};
const STORAGE_KEY='apex-crm-business-state-v3';

function normalizeOrders(orders:Order[]):Order[]{
  const now=Date.now();
  return orders.map((order,index)=>({
    ...order,
    createdAt:order.createdAt??new Date(now-index*36*60*60*1000).toISOString(),
    cost:orderCost(order),
    paidAmount:orderPaid(order),
    returnedAmount:order.returnedAmount??0,
    discount:order.discount??0,
    history:order.history?.length?order.history:[{id:`history-${order.id}`,at:order.createdAt??new Date(now-index*36*60*60*1000).toISOString(),actor:order.manager,action:'Заказ создан'}],
  }));
}

export function createInitialState():BusinessState{return {clients:fallbackClients.map((client,index)=>({...client,createdAt:client.createdAt??new Date(Date.now()-(index+12)*86400000).toISOString()})),orders:normalizeOrders(fallbackOrders),inventory:fallbackInventory,walletEntries:fallbackWalletEntries,audit:[]}}

export function loadBusinessState():BusinessState{
  try{const raw=localStorage.getItem(STORAGE_KEY);if(!raw)return createInitialState();const parsed=JSON.parse(raw) as Partial<BusinessState>;return {clients:parsed.clients??fallbackClients,orders:normalizeOrders(parsed.orders??fallbackOrders),inventory:parsed.inventory??fallbackInventory,walletEntries:parsed.walletEntries??fallbackWalletEntries,audit:parsed.audit??[]}}catch{return createInitialState()}
}

export function saveBusinessState(state:BusinessState){try{localStorage.setItem(STORAGE_KEY,JSON.stringify(state))}catch{/* Private browsing or a full storage quota must not break the CRM UI. */}}
export function resetBusinessState(){localStorage.removeItem(STORAGE_KEY)}
